import React from "react";
import { Layers, ArrowRightLeft } from "lucide-react";
import { RevealOnScroll } from "../shared";
import {
  PARTNER_POOL_SECTION,
  PARTNER_POOL_BULLETS,
  POOL_DIAGRAM,
  formatPoolLabel,
} from "./creditPoolContent";

const CreditPoolSection = () => {
  const { poolIncluded, poolUsed, usagePercent } = POOL_DIAGRAM;

  return (
    <section
      id="credit-pool"
      className="section-padding relative overflow-hidden border-t border-white/5"
      data-testid="credit-pool-section"
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <RevealOnScroll className="text-center mb-12">
          <span className="badge-mono text-partner-accent bg-[#00D2FF]/10 border border-[#00D2FF]/25 px-3 py-1.5 rounded-full inline-block mb-6">
            {PARTNER_POOL_SECTION.badge}
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 leading-tight">
            {PARTNER_POOL_SECTION.headline}{" "}
            <span className="gradient-text">{PARTNER_POOL_SECTION.headlineAccent}</span>
          </h2>
          <p className="text-partner-muted font-body max-w-2xl mx-auto leading-relaxed">
            {PARTNER_POOL_SECTION.subhead}
          </p>
        </RevealOnScroll>

        <RevealOnScroll delay={0.05}>
          <div className="rounded-2xl border border-partner bg-[#11151F] p-6 sm:p-8 mb-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#00D2FF]/10 border border-[#00D2FF]/20">
                <Layers className="h-5 w-5 text-partner-accent" />
              </div>
              <div>
                <p className="text-sm font-semibold text-partner">Example: 10× Tier 1 clients</p>
                <p className="text-xs text-partner-muted font-body">
                  Pool = {formatPoolLabel(poolUsed, poolIncluded)} ({usagePercent}% used)
                </p>
              </div>
            </div>

            <div className="w-full h-3 rounded-full bg-[#080A0F] overflow-hidden mb-6">
              <div
                className="h-full rounded-full bg-[#00D2FF] transition-all"
                style={{ width: `${usagePercent}%` }}
              />
            </div>

            <div className="grid sm:grid-cols-2 gap-4 text-sm font-body">
              <div className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-4">
                <p className="text-xs font-mono text-amber-400 uppercase tracking-wider mb-1">
                  Heavy client
                </p>
                <p className="text-partner font-semibold">Client A — 180 / 100 credits</p>
                <p className="text-partner-muted text-xs mt-1">Over soft cap; pool still OK</p>
              </div>
              <div className="rounded-xl border border-partner p-4">
                <p className="text-xs font-mono text-partner-muted uppercase tracking-wider mb-1">
                  9 lighter clients
                </p>
                <p className="text-partner font-semibold">~60 / 100 credits each</p>
                <p className="text-partner-muted text-xs mt-1">Unused capacity offsets Client A</p>
              </div>
            </div>

            <div className="mt-6 flex items-center justify-center gap-2 text-xs text-partner-muted font-mono">
              <ArrowRightLeft className="w-4 h-4 text-partner-accent" />
              Aggregate billing — not per-client silos
            </div>
          </div>
        </RevealOnScroll>

        <div className="grid sm:grid-cols-3 gap-4 mb-6">
          {PARTNER_POOL_BULLETS.map((item, i) => (
            <RevealOnScroll key={item.title} delay={0.1 + i * 0.05}>
              <div className="rounded-xl border border-partner bg-[#11151F] p-5 h-full">
                <p className="text-sm font-semibold text-partner mb-2">{item.title}</p>
                <p className="text-sm text-partner-muted font-body leading-relaxed">{item.body}</p>
              </div>
            </RevealOnScroll>
          ))}
        </div>

      </div>
    </section>
  );
};

export default CreditPoolSection;
